import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RolService } from 'src/app/services/rol.service';
import { multi } from './data';
import { CasesService } from '../../../services/cases.service';
import { SakesService } from '../../../services/sakes.service';
import { UserService } from '../../../services/user.service';
import { WidgetService } from 'src/app/services/widget.service';
import { ConexionesService } from 'src/app/services/conexiones.service';
import { take } from 'rxjs/operators';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  ultimaconexion: string = null;
  nombreCompleto: string = null;
  colorBotonCargaMasiva = '#d9d9d9';
  bienvenida = true;
  casos = 0;
  sakes = 0;
  usuariosBloqueados = 0;
  multi: any[] = multi;
  colorScheme = {
    domain: ['#11B2FF', '#008CDC', '#61D2FE', '#AAAAAA'],
  };
  singlegetCasosAnalizados = [];
  singleMisMontos = [];
  multiMisCanales = [];
  multiCasosAnalista = [];
  multiCanalesAnalista = [];
  showXAxis = true;
  showYAxis = true;

  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;

  xAxisLabelCasosAnalizados = 'Nombre';
  yAxisLabelCasosAnalizados = 'Dias de Ejecucion';
  xAxisLabelMisCanales = 'Canales';
  yAxisLabelMisCanales = 'Montos';
  xAxisLabelMisMontos = 'Tipo de Monto';
  yAxisLabelMisMontos = 'Montos';
  xAxisLabelCasosAnalista = 'Usuarios';
  yAxisLabelCasosAnalista = 'Datos';
  xAxisLabelCanalesAnalista = 'Usuarios';
  yAxisLabelCanalesAnalista = 'Montos';

  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  timeline: boolean = true;
  view: any[] = [700, 400];

  widgetCasos: boolean = false;
  widgetCanales: boolean = false;
  widgetMontos: boolean = false;
  widgetCasosAll: boolean = false;
  widgetCanalesAll: boolean = false;
  widgetNotificaciones: boolean = false;

  constructor(
    public conexionesService: ConexionesService,
    private dialog: MatDialog,
    private router: Router,
    private http: HttpClient,
    public userService: UserService,
    public sakesService: SakesService,
    public casosService: CasesService,
    public rolService: RolService,
    public widgetServices: WidgetService,
    private _notificaciones: NotificacionService,
    private _casos: CasoTareaService
  ) {
    this.checkPermissions();
  }

  checkPermissions() {
    let permisos = this.rolService.permisos;
    for (let i in permisos) {
      permisos[i].indexOf('Casos Analizados') !== -1
        ? (this.widgetCasos = true)
        : null;
      permisos[i].indexOf('Canales') !== -1
        ? (this.widgetCanales = true)
        : null;
      permisos[i].indexOf('Montos') !== -1 ? (this.widgetMontos = true) : null;
      permisos[i].indexOf('Casos de Todos los Analistas') !== -1
        ? (this.widgetCasosAll = true)
        : null;
      permisos[i].indexOf('Canales de Todos los Analistas') !== -1
        ? (this.widgetCanalesAll = true)
        : null;
      permisos[i].indexOf('Ultimas Notificaciones') !== -1
        ? (this.widgetNotificaciones = true)
        : null;
      console.log('WidgetNotificaciones', this.widgetNotificaciones);
    }
    Object.assign(this, { multi });
  }

  onSelect(data): void {}

  onActivate(data): void {}

  onDeactivate(data): void {}

  ngOnInit(): void {
    this.getLastConexion();
    this.userService
      .getUserProfile(parseInt(sessionStorage.getItem('id_usuario')))
      .subscribe((resp) => {
        this.nombreCompleto = `${resp.payload.nombre} ${resp.payload.apellido}`;
      });

    this.userService.getUsers().subscribe((data: any) => {
      for (let x in data.payload) {
        if (data.payload[x].estatus == 'bloqueado') {
          this.usuariosBloqueados += 1;
        }
      }
    });

    this.widgetServices
      .getCasosAnalizados(sessionStorage.getItem('id_usuario'))
      .subscribe((resp) => {
        resp.payload.forEach((element: any) => {
          let data = {
            name: element.caso.nombre,
            value: element.dias_analisis,
          };
          this.singlegetCasosAnalizados.push(data);
        });
        this.singlegetCasosAnalizados = [...this.singlegetCasosAnalizados];
      });

    // --Cantitdad de BS por canales por analista.

    this.widgetServices
      .getMisCanales(sessionStorage.getItem('id_usuario'))
      .subscribe((resp) => {
        resp.payload.forEach((element) => {
          let data = {
            name: element.canal,
            series: [
              {
                name: 'Monto Ejecutado',
                value: element.montos.monto_ejecutado,
              },
              {
                name: 'Monto Retenido',
                value: element.montos.monto_retenido,
              },
            ],
          };
          this.multiMisCanales.push(data);
        });
        this.multiMisCanales = [...this.multiMisCanales];
      });

    // --Monto Ejecutado total, monto salvado total, monto perdido total por analista.

    this.widgetServices
      .getMisMontos(sessionStorage.getItem('id_usuario'))
      .subscribe((resp) => {
        this.singleMisMontos = [
          {
            name: 'Monto Ejecutado',
            value: resp.payload.monto_ejecutado,
          },
          {
            name: 'Monto Retenido',
            value: resp.payload.monto_retenido,
          },
        ];
        this.singleMisMontos = [...this.singleMisMontos];
      });

    // -- Total Casos Analizados: Cantidad de casos asignados TODOS los analista y dias de analisis desde la fecha de asignación.

    this.widgetServices.getCasosAnalistas().subscribe((resp) => {
      resp.payload.forEach((element) => {
        let dias = 0;
        element.casos.forEach((element2) => {
          dias += element2.dias_analisis;
        });
        let data = {
          name: element.analista.nombre,
          series: [
            {
              name: 'Cantidad de Casos',
              value: element.casos.length,
            },
            {
              name: 'Dias Analisis',
              value: dias,
            },
          ],
        };
        this.multiCasosAnalista.push(data);
      });
      this.multiCasosAnalista = [...this.multiCasosAnalista];
    });

    // f- Total Canales: Cantitdad de BS por canales de TODOS los analistas.

    this.widgetServices.getCanalesAnalistas().subscribe((resp) => {
      resp.payload.forEach((element) => {
        element.canales.forEach((element2) => {
          let data = {
            name: element.analista.nombre,
            series: [
              {
                name: `Monto Ejecutado ${element2.canal}`,
                value: element2.montos.monto_ejecutado,
              },
              {
                name: `Monto Retenido ${element2.canal}`,
                value: element2.montos.monto_retenido,
              },
            ],
          };
          this.multiCanalesAnalista.push(data);
        });
      });
      this.multiCanalesAnalista = [...this.multiCanalesAnalista];
    });

    this.sakesService.obtenerTodos().subscribe((data: any) => {
      this.sakes = data.payload.length;
    });
    this.casosService.getCases().subscribe((data: any) => {
      this.casos = data.payload.length;
    });
  }

  cerrar() {
    this.bienvenida = false;
  }

  getLastConexion() {
    this.conexionesService
      .getLastConexion(parseInt(sessionStorage.getItem('id_usuario')))
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          console.log('Respuesta de la ultima conexion', response.payload);
          const date = new Date(response.payload);
          this.ultimaconexion = `${this.getDay(
            date.getDay()
          )} ${date.getDate()}/${
            date.getMonth() + 1
          }/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
        },
        (err) => {
          console.log('ERROR', err);
        }
      );
  }

  getDay(day: number): string {
    console.log('Día de la ultima conexion', day);
    switch (day) {
      case 1:
        return 'Lunes';
      case 2:
        return 'Martes';
      case 3:
        return 'Miercoles';
      case 4:
        return 'Jueves';
      case 5:
        return 'Viernes';
      case 6:
        return 'Sabado';
      case 7:
        return 'Domingo';
      default:
        return null;
    }
  }
}
